import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { HeaderComponent } from "../header/HeaderComponent";
import { useEffect, useState } from "react";
import { RotateLoader } from "react-spinners";
import "../../../src/index.css";
import circularLogo from "../../assets/greedy_logo_circular_solid_footer.webp";
import Footer from "../footer/Footer";
import { useLanguageContext } from "../../context/languageContext";

export const MainLayout = () => {
  const [loading, setLoading] = useState(true);
  const [changeColor, setChangeColor] = useState(true);
  const location = useLocation();
  const { languageSelected } = useLanguageContext();

  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/contact") {
      setChangeColor(false);
    } else {
      setChangeColor(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    setLoading(true);
  }, [languageSelected, location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, [location.pathname, languageSelected]);

  return (
    <Box>
      {loading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Box
            component="img"
            src={circularLogo}
            alt="Greedy logo"
            sx={{ width: "100px", height: "100px", mb: "20px" }}
          />
          <RotateLoader color="#7F8CAA" />
        </Box>
      )}
      {!loading && <HeaderComponent />}
      {!loading && <Outlet />}
      {!loading && <Footer changeColor={changeColor} />}
    </Box>
  );
};
